"use client";

import { useActivePianoNotes } from "./use-active-piano-notes";

/**
 * Returns true when ALL given MIDI notes are currently pressed
 * (octave-strict, exact MIDI match, not pitch-class).
 *
 * Different semantics from `usePressedPitchClasses` (octave-agnostic) :
 * here we compare on raw MIDI numbers, so a chord voicing can only be
 * validated when the student plays it at the *exact* register the
 * exercise expects. Used by progression auto-advance and by any other
 * feature that needs strict voicing detection.
 */
export function useMidiSetHit(midis: readonly number[]): boolean {
  const active = useActivePianoNotes();

  if (midis.length === 0) {
    return false;
  }

  return midis.every((m) => active.has(m));
}
